"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dropdown = _interopRequireDefault(require("../../Dropdown/Dropdown"));

var _UserNav = _interopRequireDefault(require("./UserNav"));

var _Avatar = _interopRequireDefault(require("../../Avatar/Avatar"));

var _Typography = _interopRequireDefault(require("../../Typography/Typography"));

var _Responsive = _interopRequireDefault(require("../../Responsive/Responsive"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import * as utils from '../../../shared';

/**
User dropdown for header bar
*/
function UserDropdown(_ref) {
  var children = _ref.children,
      name = _ref.name,
      avatar = _ref.avatar,
      defaultOpen = _ref.defaultOpen;
  return /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    defaultOpen: defaultOpen,
    padding: {
      all: 'none'
    },
    position: "right"
  }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"].Trigger, {
    componentEl: "button",
    type: "button",
    className: "st_usernav__trigger"
  }, name && /*#__PURE__*/_react["default"].createElement(_Responsive["default"], {
    sm: true,
    md: true,
    lg: true
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    margin: {
      right: 'sm'
    },
    size: "md"
  }, name)), /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    avatar: avatar,
    size: "lg",
    initials: name && name.charAt(0) || ' '
  })), /*#__PURE__*/_react["default"].createElement(_Dropdown["default"].Content, null, /*#__PURE__*/_react["default"].createElement(_UserNav["default"], null, children)));
}

UserDropdown.propTypes = {
  /** whether dropdown is open or closed by default */
  defaultOpen: _propTypes["default"].bool,

  /** user name to display */
  name: _propTypes["default"].string,

  /** avatar of user, if any */
  avatar: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})])
};
UserDropdown.defaultProps = {
  defaultOpen: false,
  name: null,
  avatar: null
};
UserDropdown.displayName = 'HeaderBar.User.Dropdown';
var _default = UserDropdown;
exports["default"] = _default;